const extenso = require('extenso')
export const utils = {
    filters: {

        calcAge (dateString) {
            if(!dateString) return ''
            const birthday = +new Date(dateString);
            return ~~((Date.now() - birthday) / (31557600000));
        },

        cpf (cpf) {
            if(!cpf) return ''
            cpf=cpf.replace(/\D/g,"")
            cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
            cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
            cpf=cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
            return cpf
        },

        cnpj (cnpj) {
            if(!cnpj) return ''
            cnpj=cnpj.replace(/\D/g,"")
            cnpj=cnpj.replace(/^(\d{2})(\d)/,"$1.$2")
            cnpj=cnpj.replace(/^(\d{2})\.(\d{3})(\d)/,"$1.$2.$3")
            cnpj=cnpj.replace(/\.(\d{3})(\d)/,".$1/$2")
            cnpj=cnpj.replace(/(\d{4})(\d)/,"$1-$2")
            return cnpj
        },

        tel (tel) {
            if(!tel) return ''
            tel=tel.replace(/\D/g,"")
            tel=tel.replace(/^(\d)/,"($1")
            tel=tel.replace(/(.{3})(\d)/,"$1)$2")
            if(tel.length == 9) {
                tel=tel.replace(/(.{1})$/,"-$1")
            } else if (tel.length == 10) {
                tel=tel.replace(/(.{2})$/,"-$1")
            } else if (tel.length == 11) {
                tel=tel.replace(/(.{3})$/,"-$1")
            } else if (tel.length == 12) {
                tel=tel.replace(/(.{4})$/,"-$1")
            } else if (tel.length > 12) {
                tel=tel.replace(/(.{4})$/,"-$1")
            }
            return tel;
        },

        cep (cep) {
            if(!cep) return ''
            cep=cep.replace(/\D/g,"")
            cep=cep.replace(/^(\d{2})(\d)/,"$1.$2")
            cep=cep.replace(/\.(\d{3})(\d)/,".$1-$2")
            return cep
        },

        moeda(numero) {
            var numero = numero.toFixed(2).split('.');
            numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join('.');
            return numero.join(',');
        }

    },

    methods:{
        idade (dateString) {
            if(!dateString) return ''
            const birthday = +new Date(dateString);
            return ~~((Date.now() - birthday) / (31557600000));
        },
        formatcpf (cpf) {
            if(!cpf) return ''
            cpf=cpf.replace(/\D/g,"")
            cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
            cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
            cpf=cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
            return cpf
        },
        formattel (tel) {
            if(!tel) return ''
            tel=tel.replace(/\D/g,"")
            tel=tel.replace(/^(\d)/,"($1")
            tel=tel.replace(/(.{3})(\d)/,"$1)$2")
            if(tel.length == 9) {
                tel=tel.replace(/(.{1})$/,"-$1")
            } else if (tel.length == 10) {
                tel=tel.replace(/(.{2})$/,"-$1")
            } else if (tel.length == 11) {
                tel=tel.replace(/(.{3})$/,"-$1")
            } else if (tel.length == 12) {
                tel=tel.replace(/(.{4})$/,"-$1")
            } else if (tel.length > 12) {
                tel=tel.replace(/(.{4})$/,"-$1")
            }
            return tel;
        },
        total(...val){
            return val.reduce((a,b)=> parseFloat(a) + parseFloat(b), 0)
        },
        monetize (value) {
            if(!value) return 'R$ 0,00';
            value = parseFloat(value).toFixed(2);
            value = value.toString();
            return 'R$' + value.replace('.', ',');
        },
        real(numero) {
            if(!numero) return 'R$ 0,00';
            var numero = numero.toFixed(2).split('.');
            numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join('.');
            return numero.join(',');
        },
        realx(...numero){
            if(!numero[0]) return 'R$ 0,00';
            const retorno = []
            numero.map(item => {
                var num = parseFloat(item).toFixed(2).split('.')
                num[0] = "R$ " + num[0].split(/(?=(?:...)*$)/).join('.');
                retorno.push(num.join(','))
            });
            return retorno.toString()
        },

        currency(val){
            const moeda = val.toFixed(2).replace('.',',')
            const money = extenso(moeda , { mode: 'currency', currency: { type: 'BRL' } })
            return money
        }
    },

}


// WEBPACK FOOTER //
// ./src/components/relatorios/mixins/index.js